<app-header></app-header>

<!-- <link
  href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"
  rel="stylesheet"
  id="bootstrap-css"
/>
<script src="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script> -->
<!------ Include the above in your HEAD tag ---------->

<div class="container-xxl">
  <section class="banner d-flex justify-content-center align-items-center text-center">
    <div class="content"  data-aos="zoom-in" data-aos-duration="2000">
      <div class="title">
        <span>الحساب</span>
      </div>
    
      <div class="links">
        <a class="text-decoration-none" href="/home"> الرئيسية </a>
        <span> / الحساب </span>
      </div>
    </div>
  </section>
<!-- 
<div class="container emp-profile">
  <form method="post">
    <div class="row">
      <div class="col-md-4">
        <div class="profile-img">
          <img
            src="https://khairokom-uploadfiles.azurewebsites.net/files/{{
              user.img
            }}"
            alt=""
          />
          <img src="{{user.img}}" alt=""/>
        </div>
      </div>
      <div class="col-md-8">
        <div class="profile-head">
          <h3>
            {{ user.userName }}
          </h3>

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="home-tab"
                data-toggle="tab"
                role="tab"
                aria-controls="home"
                aria-selected="true"
                > معلومات عن {{user.userName}} </a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="profile-work"></div>
      </div>
      <div class="col-md-8">
        <div class="tab-content profile-tab" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="row">
              <div class="col-md-6">
                <label>User Id</label>
              </div>
              <div class="col-md-6">
                <p>{{ id }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>الاسم</label>
              </div>
              <div class="col-md-6">
                <p>{{ user.userName }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>البريد الإلكتروني</label>
              </div>
              <div class="col-md-6">
                <p>{{ user.email }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>تاريخ الميلاد</label>
              </div>
              <div class="col-md-6">
                <p>{{ user.birthDate | date :'short'}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>النوع</label>
              </div>
              <div class="col-md-6">
                <p>{{ user.gender }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>مسجل كـ:</label>
              </div>
              <div class="col-md-6">
                <p>{{ user.roles }}</p>
              </div>
            </div>
            <div class="d-flex justify-content-between">
                <a class="btn btn-warning" routerLink="/updateUser/{{ id }}">
                    تعديل حسابي
                  </a>
      
                  <a class="btn btn-primary" (click)="delete()">حذف الحساب</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div> -->

<section class="profile">
  <div class="container">
    <div class="row">
      <div class="col-md-3 mt-5 mb-5 text-center"  data-aos="fade-left" data-aos-duration="2000">
        <div class="profile-img">
          <img class="img-fluid rounded-circle" src="https://khairokom-uploadfiles.azurewebsites.net/files/{{user.img}}" alt="صورة الحساب"/>
        </div>
        <div class="user-name mt-3">
          <h3>{{ user.userName }}</h3>
        </div>
        <div class="email">
          <p>{{ user.email }}</p>
        </div>
        <div class="birthdate" *ngIf="visitorUserId==user._id">
          <p>{{ user.birthDate | date :'shortDate'}}</p>
        </div>
        <div class="country">
          <p>{{ user.country }}</p>
        </div>
        <div class="d-flex justify-content-center" *ngIf="visitorUserId==user._id">
          <a class="btn btn-warning" routerLink="/updateUser/{{ id }}">تعديل حسابي</a>
          <a class="btn btn-dark" (click)="delete()">حذف الحساب</a>
      </div>
      </div>

      <div class="edu col-md-9 mt-5 mb-5">
        <div class="courses" routerLink="/myCourses/{{id}}" *ngIf="visitorUserId==user._id" style="cursor:pointer"  data-aos="flip-down" data-aos-duration="2000">
          <h2 class="title"> <i class="fas fa-chalkboard-teacher" ></i> &nbsp; دوراتي التدريبية</h2>
        </div>

   <!--      <div class="favourit mt-4">
          <h2 class="title"> <i class="far fa-bookmark"></i> &nbsp; المفضلة</h2>
        </div>
    -->
        <div class="rate mt-4"  data-aos="flip-down" data-aos-duration="2000">
          <h2 class="title"> <i class="far fa-star"></i> &nbsp; التقييم كمعلم</h2>
          <div class="stars text-center" *ngIf="thereIsFeedbackAsTeacher">
          <i *ngFor='let in of counter(AbsTeacherStars) ;let i = index' class="filledStar fas fa-star" ></i>
           <i *ngFor='let in of counter(5-AbsTeacherStars) ;let i = index' class="star fas fa-star" ></i>
          </div>
        </div>

        <div class="certificate mt-4" *ngIf="visitorUserId==user._id"  data-aos="flip-down" data-aos-duration="2000">
          <h2 class="title"> <i class="fas fa-medal"></i> &nbsp; أوسمتك فى رحلة طلبك للعلم <sub style="font-size: 10px;"> اضغط على الوسام للانتقال الى المجموعة الخاصة به</sub></h2>
          <div class="text-center"  *ngIf="thereIsFeedbackAsStudent">
            <i *ngFor="let f of feedbacksAsStudent" routerLink="/getClassById/{{f.classId}}"
             [ngClass]="{'gold':f.starsNumber==5,
                          'silver':f.starsNumber==4||f.starsNumber==3,
                          'bronze':f.starsNumber==2||f.starsNumber==1}" 
            class=" fas fa-medal"
            data-toggle="tooltip"
            title="{{f.message}} "
            (mouseenter)="getClassNumber(f._id)"
            ></i>        
           
          
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</div>


<app-footer></app-footer>
